export default {
  computed: {
    listInstrumen() {
      let result = [];

      for (const ins of this.instrumen) {
        const items = (ins.opsi || []).map((opsi) => {
          return {
            text: opsi.keterangan,
            value: opsi.k_lingkup_opsi_psp,
            is_lain: opsi.is_lain,
            validator: opsi.validator,
          };
        });
        const othersValue = items.filter((item) => item.is_lain === 1);
        const otherValue = othersValue[0] || {};

        let desc = '';
        if (+ins.k_lingkup_instrumen_psp === 1) {
          desc =
            '(Centang pada tingkat kelas yang telah menerapkan kurikulum merdeka. Kemudian isikan jumlah rombelnya berapa)';
        } else if ([2, 7, 9].includes(+ins.k_lingkup_instrumen_psp)) {
          desc = '(Deskripsi minimal 30 kata)';
        }

        const validators = (ins.validator || '').split('|');
        let validator = {};
        for (const item of validators) {
          if (item) {
            const val = item.split(':');
            validator[val[0]] = val[1];
          }
        }

        let counter = false;
        if (validator.min_words) {
          counter = validator.min_words;
        } else if (othersValue.length) {
          counter = {};
          for (const val of othersValue) {
            const validators = (val.validator || '').split('|');
            let validator = {};
            for (const item of validators) {
              if (item) {
                const val = item.split(':');
                validator[val[0]] = val[1];
              }
            }

            counter[val.value] = validator.min_words || false;
          }
        }

        if (ins.tipe === 'checkbox') {
          result.push({
            id: (ins.k_lingkup_instrumen_psp || '').toString(),
            type: 'Checkbox',
            name: `instrumen-checkbox-${ins.k_lingkup_instrumen_psp}`,
            desc: desc,
            label: ins.keterangan,
            labelColor: 'indigo',
            items,
            hideDetails: true,
            row: +ins.k_lingkup_instrumen_psp !== 1,
            singleLine: true,
            notitle: true,
            class: 'mb-0',
            grid: { cols: 12 },
            itemGrid: { cols: 12, lg: 4 },
            isOpsiLain: +ins.k_lingkup_instrumen_psp === 1,
            useOthers: +ins.k_lingkup_instrumen_psp !== 1,
            othersValue: +otherValue.value,
            others: {
              type: 'VTextarea',
              name: `input-lain-${ins.k_lingkup_instrumen_psp}-${otherValue.value}`,
              label: 'Tuliskan jawaban lainnya',
              placeholder: 'Tuliskan jawaban lainnya',
              hint: 'wajib diisi',
              required: true,
              outlined: true,
              dense: true,
              singleLine: true,
              hideDetails: true,
              rows: 2,
              autoGrow: true,
              grid: { cols: 12, md: 6 },
            },
            othersOpsi: {
              type: 'number',
            },
          });
        } else if (ins.tipe === 'radio') {
          result.push({
            id: (ins.k_lingkup_instrumen_psp || '').toString(),
            type: 'VRadio',
            name: `instrumen-radio-${ins.k_lingkup_instrumen_psp}`,
            label: ins.keterangan,
            labelColor: 'indigo',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            hint: 'wajib diisi',
            items,
            customClass: 'mt-0',
            hideDetails: true,
            outlined: true,
            dense: true,
            row: items.length < 3,
            singleLine: false,
            grid: { cols: 12, md: 12 },
            useOthers: true,
            othersValue: othersValue.map((val) => +val.value),
            others: {
              type: 'VTextarea',
              name: `input-lain-${ins.k_lingkup_instrumen_psp}-${otherValue.value}`,
              label: `Tuliskan jawaban ${
                counter[this.form[`instrumen-radio-${ins.k_lingkup_instrumen_psp}`]]
                  ? `(minimal ${counter[this.form[`instrumen-radio-${ins.k_lingkup_instrumen_psp}`]]} kata)`
                  : ''
              }`,
              placeholder: `Tuliskan jawaban ${
                counter[this.form[`instrumen-radio-${ins.k_lingkup_instrumen_psp}`]]
                  ? `(minimal ${counter[this.form[`instrumen-radio-${ins.k_lingkup_instrumen_psp}`]]} kata)`
                  : ''
              }`,
              hint: counter[this.form[`instrumen-radio-${ins.k_lingkup_instrumen_psp}`]]
                ? `Deskripsi minimal ${counter[this.form[`instrumen-radio-${ins.k_lingkup_instrumen_psp}`]]} kata`
                : '',
              required: true,
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
              counter: counter,
              counterValue: (v) => this.$wordCount(v),
              grid: { cols: 12, md: 6 },
            },
          });
        } else if (ins.tipe === 'number') {
          result.push({
            id: (ins.k_lingkup_instrumen_psp || '').toString(),
            type: 'VTextField',
            name: `instrumen-input-${ins.k_lingkup_instrumen_psp}`,
            label: ins.keterangan,
            labelColor:
              this.isNotEmpty &&
              !this.form[`instrumen-input-${ins.k_lingkup_instrumen_psp}`] &&
              this.form[`instrumen-input-${ins.k_lingkup_instrumen_psp}`] !== 0
                ? 'red'
                : 'indigo',
            hint: '',
            mask: '#####',
            customClass: 'mt-0',
            placeholder: 'Tuliskan angka',
            outlined: true,
            singleLine: true,
            hideDetails: true,
            dense: true,
            readonly: this.isPreview,
            grid: { cols: 12, md: 6, sm: 12 },
          });
        } else if (ins.tipe === 'textarea') {
          result.push({
            id: (ins.k_lingkup_instrumen_psp || '').toString(),
            type: 'VTextarea',
            name: `instrumen-input-${ins.k_lingkup_instrumen_psp}`,
            label: ins.keterangan,
            labelColor: validator.min_words
              ? !!this.form[`instrumen-input-${ins.k_lingkup_instrumen_psp}`] &&
                this.$wordCount(this.form[`instrumen-input-${ins.k_lingkup_instrumen_psp}`] || '') < validator.min_words
                ? 'red'
                : 'indigo'
              : 'indigo',
            customClass: 'mt-0',
            placeholder: `Tuliskan jawaban ${validator.min_words ? `(minimal ${validator.min_words} kata)` : ''}`,
            hint: validator.min_words ? `Deskripsi minimal ${validator.min_words} kata` : '',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.isPreview,
            rows: 3,
            autoGrow: true,
            counter: true,
            counterValue: (v) => this.$wordCount(v),
            grid: { cols: 12, md: 12, sm: 12 },
          });
        } else if (ins.tipe === 'date') {
          result.push({
            id: (ins.k_lingkup_instrumen_psp || '').toString(),
            type: 'VDatePicker',
            name: `instrumen-input-${ins.k_lingkup_instrumen_psp}`,
            label: ins.keterangan,
            labelColor: 'indigo',
            usePrependInnerIcon: 'mdi-calendar-month',
            hint: 'wajib diisi',
            required: true,
            outlined: true,
            singleLine: true,
            disabled: this.isPreview,
            hideDetails: true,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          });
        }
      }

      return result;
    },

    listGdrive() {
      const inputs = [
        {
          label: 'Dokumentasi praktik baik dalam implementasi kurikulum Merdeka',
          name: 'praktik-kurikulum',
        },
        {
          label: 'Dokumentasi praktik baik dalam komunitas belajar dalam sekolah',
          name: 'praktik-komunitas',
        },
        {
          label: 'Dokumentasi pengimbasan yang dilakukan ke sekolah lain (bahan materi pengimbasan)',
          name: 'praktik-imbas',
        },
        {
          label: 'Dokumentasi praktik baik dalam perencanaan berbasis data',
          name: 'praktik-data',
        },
        {
          label: 'Dokumentasi praktik baik dalam digitalisasi sekolah',
          name: 'praktik-digital',
        },
      ];

      let result = [];

      for (const input of inputs) {
        result.push({
          key: input.name,
          label: input.label,
          type: 'gdrive',
          berkases: this.berkases.filter((berkas) => berkas.jenis === input.name),
        });
      }

      return result;
    },

    schema2023() {
      const umum = [
        {
          title: '<strong class="black--text" style="font-size: 18px">Gambaran Umum Kegiatan</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'textView',
              label: `Jenjang Sekolah`,
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2',
              value: this.$getDeepObj(this.initValue, 'sekolah.data.m_jenjang.data.singkat') || '-',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Provinsi Sekolah`,
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2',
              value: this.$getDeepObj(this.initValue, 'sekolah.data.m_propinsi.data.keterangan') || '-',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Kab / Kota Sekolah`,
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2',
              value: this.$getDeepObj(this.initValue, 'sekolah.data.m_kota.data.keterangan') || '-',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `JP Kegiatan`,
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2',
              value: '3',
              grid: { cols: 12, md: 6 },
            },
            {
              disabled: this.isPreview,
              type: 'VRadio',
              name: 'k_lingkup_moda_psp',
              label: 'Pelaksanaan Kunjungan Lapangan',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              required: true,
              row: true,
              items: this.$mapForMaster(this.masters['lingkup_moda_psp']),
              grid: { cols: 12, md: 6 },
            },
            {
              disabled: this.isPreview,
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan',
              placeholder: 'Isikan tanggal pelaksanaan',
              label: 'Waktu Pelaksanaan',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
          ],
        },
      ];

      const pelaksanaan = [
        {
          title: '<strong class="black--text" style="font-size: 18px">Pelaksanaan Kegiatan</strong>',
          grid: 12,
          instrumen: this.listInstrumen,
          berkas: this.listGdrive,
          berkasClass: 'mt-4',
        },
      ];

      const lampiran = [
        {
          title: '<strong class="black--text" style="font-size: 18px">Lampiran</strong>',
          grid: 12,
          type: 'berkas',
          customClass: 'mt-5',
          berkas: [
            {
              key: 'hadir',
              label: 'Daftar Hadir',
              desc: '(Sematkan minimal 1 dokumen)',
              berkases: this.berkases.filter((berkas) => berkas.jenis === 'hadir'),
            },
            {
              key: 'foto',
              maks: 1,
              type: 'gdrive',
              label: 'Dokumentasi Kegiatan',
              desc: '(Inputkan link google drive)',
              berkases: this.berkases.filter((berkas) => berkas.jenis === 'foto'),
            },
            {
              key: 'tugas',
              maks: 1,
              label: 'Surat Tugas Fasilitator',
              desc: '(Lampirkan file pdf atau jpg)',
              berkases: this.berkases.filter((berkas) => berkas.jenis === 'tugas'),
            },
            {
              key: 'dinas',
              maks: 1,
              type: 'gdrive',
              label: 'Tautan folder bukti perjalanan dan laporan perjalanan dinas',
              desc: '(Inputkan link google drive)',
              berkases: this.berkases.filter((berkas) => berkas.jenis === 'dinas'),
            },
          ],
        },
      ];

      return [...umum, ...pelaksanaan, ...lampiran];
    },
  },
};
